import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import forceRankAxios from '../../axios/forceRank'
import horizontalAxios from '../../axios/horizontalForceRank'
import baseAxios from '../../axios/base'

// index_calculate_list
export const fetchHorizontalForceRank = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions
      //   page: filterOptions ? filterOptions.page : 1,
      //   perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchHorizontalForceRankStart())
    horizontalAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          dispatch(fetchHorizontalForceRankSuccess(data))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Fetch Horizontal ForceRank Failed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break
          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        if (error.response.status !== 404) {
          dispatch(fetchHorizontalForceRankFailed(error))
        }
      })
  }
}

export const fetchHorizontalForceRankStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_START
  }
}

export const fetchHorizontalForceRankSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FAILED,
    errorMessage
  }
}

export const fetchHorizontalForceRankBoard = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions
      //   page: filterOptions ? filterOptions.page : 1,
      //   perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchHorizontalForceRankBoardStart())
    baseAxios
      .get('/force_rank_horizon_board', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          dispatch(fetchHorizontalForceRankBoardSuccess(data))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Fetch Horizontal ForceRank Failed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break
          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        if (error.response.status !== 404) {
          dispatch(fetchHorizontalForceRankBoardFailed(error))
        }
      })
  }
}

export const fetchHorizontalForceRankBoardStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_START
  }
}

export const fetchHorizontalForceRankBoardSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankBoardFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FAILED,
    errorMessage
  }
}

export const fetchHorizontalForceRankFilter = filterOptions => {
  return dispatch => {
    // const params = {
    //   ...filterOptions,
    //   page: filterOptions ? filterOptions.page : 1,
    //   perPage: filterOptions ? filterOptions.perPage : 10
    // }

    dispatch(fetchHorizontalForceRankFilterStart())

    horizontalAxios
      .post('/calculate', filterOptions)
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          dispatch(fetchHorizontalForceRankFilterSuccess(data))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankFilterFailed(error))
      // })
      .catch(error => {
        if (error.response?.status) {
          switch (error.response.status) {
            default:
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.data.Error,
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchHorizontalForceRankFilterFailed())
      })
  }
}

export const fetchHorizontalForceRankFilterStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_START
  }
}

export const fetchHorizontalForceRankFilterSuccess = (data, pagination, total) => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_SUCCESS,
    data,
    pagination,
    total
  }
}

export const fetchHorizontalForceRankFilterFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_FAILED,
    errorMessage
  }
}

export const fetchHorizontalForceRankBoardFilter = filterOptions => {
  return dispatch => {
    // const params = {
    //   ...filterOptions,
    //   page: filterOptions ? filterOptions.page : 1,
    //   perPage: filterOptions ? filterOptions.perPage : 10
    // }

    dispatch(fetchHorizontalForceRankBoardFilterStart())

    baseAxios
      .post('/force_rank_horizon_board/calculate', filterOptions)
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          dispatch(fetchHorizontalForceRankBoardFilterSuccess(data))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankFilterFailed(error))
      // })
      .catch(error => {
        if (error.response?.status) {
          switch (error.response.status) {
            default:
              dispatch(
                enqueueSnackbar({
                  message: error?.response?.data?.data?.Error,
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchHorizontalForceRankBoardFilterFailed())
      })
  }
}

export const fetchHorizontalForceRankBoardFilterStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_START
  }
}

export const fetchHorizontalForceRankBoardFilterSuccess = (data, pagination, total) => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_SUCCESS,
    data,
    pagination,
    total
  }
}

export const fetchHorizontalForceRankBoardFilterFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_FAILED,
    errorMessage
  }
}

export const createHorizontalForceRank = (company_id, recordData, page) => {
  return dispatch => {
    dispatch(createHorizontalForceRankStart())

    horizontalAxios
      .patch(`/${company_id}`, recordData)
      .then(response => {
        // if (response.status === 201) {
        dispatch(
          enqueueSnackbar({
            message: 'Horizontal Force Rank Save',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(createHorizontalForceRankSuccess())
        window.location.reload()
        // }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'InvalidAdjustGradeField',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createHorizontalForceRankFailed())
      })
  }
}

export const createHorizontalForceRankStart = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_START
  }
}
export const createHorizontalForceRankSuccess = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_SUCCESS
  }
}
export const createHorizontalForceRankFailed = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_FAILED
  }
}

export const createHorizontalForceRankBoard = (company_id, recordData, page) => {
  return dispatch => {
    dispatch(createHorizontalForceRankBoardStart())

    baseAxios
      .patch(`force_rank_horizon_board/horizon_board/${company_id}`, recordData)
      .then(response => {
        // if (response.status === 201) {
        dispatch(
          enqueueSnackbar({
            message: 'Horizontal Force Rank Save',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(createHorizontalForceRankBoardSuccess())
        window.location.reload()
        // }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'InvalidAdjustGradeField',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createHorizontalForceRankBoardFailed())
      })
  }
}

export const createHorizontalForceRankBoardStart = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_START
  }
}
export const createHorizontalForceRankBoardSuccess = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_SUCCESS
  }
}
export const createHorizontalForceRankBoardFailed = () => {
  return {
    type: actionTypes.CREATE_HORIZONTAL_FORCERANK_FAILED
  }
}

export const fetchHorizontalForceRankFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchHorizontalForceRankFilterCompanyStart())
    forceRankAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchHorizontalForceRankFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchHorizontalForceRankFilterCompanyFailed(error))
      })
  }
}

export const fetchHorizontalForceRankFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_START
  }
}

export const fetchHorizontalForceRankFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchHorizontalForceRankGrade = () => {
  return dispatch => {
    dispatch(fetchHorizontalForceRankGradeStart())
    forceRankAxios
      .get('/grade_and_count_force_rank')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchHorizontalForceRankGradeSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchHorizontalForceRankGradeFailed(error))
      })
  }
}

export const fetchHorizontalForceRankGradeStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_START
  }
}

export const fetchHorizontalForceRankGradeSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankGradeFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_GRADE_FAILED,
    errorMessage
  }
}

// Force Rank List

export const fetchHorizontalForceRankList = data => {
  return dispatch => {
    dispatch(fetchHorizontalForceRankListStart())
    forceRankAxios
      .post('/force_rank', data)
      .then(response => {
        // if (response.status === 200) {
        //   dispatch(fetchForceRankListSuccess(response.data.data))
        // }
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'ForceRankSuccess',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchHorizontalForceRankListSuccess(response.data.data))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankListFailed(error))
      // })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchHorizontalForceRankListFailed())
      })
  }
}

export const fetchHorizontalForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_START
  }
}

export const fetchHorizontalForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_FAILED,
    errorMessage
  }
}

// Force Rank List (2)

export const fetchReStoreHorizontalForceRankList = data => {
  return dispatch => {
    dispatch(fetchReStoreHorizontalForceRankListStart())
    horizontalAxios
      .post('/horizon', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'ForceRankSuccess',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchReStoreHorizontalForceRankListSuccess(response.data.data))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchReStoreHorizontalForceRankListFailed())
      })
  }
}

export const fetchReStoreHorizontalForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_LIST_START
  }
}

export const fetchReStoreHorizontalForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_SUCCESS,
    data
  }
}

export const fetchReStoreHorizontalForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_TABLE_FAILED,
    errorMessage
  }
}

export const fetchHorizontalForceRankCalculate = data => {
  return dispatch => {
    dispatch(fetchHorizontalForceRankCalculateStart())
    forceRankAxios
      .post('/calculate_index', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchHorizontalForceRankCalculateSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchHorizontalForceRankCalculateFailed(error))
      })
  }
}

export const fetchHorizontalForceRankCalculateStart = () => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_START
  }
}

export const fetchHorizontalForceRankCalculateSuccess = data => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_SUCCESS,
    data
  }
}

export const fetchHorizontalForceRankCalculateFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_HORIZONTAL_FORCERANK_CALCULATE_FAILED,
    errorMessage
  }
}

// Adjust

export const fetchAdjust = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchAdjustStart())

    forceRankAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200) {
          const { current_page, from, last_page, per_page, to, total, data } =
            response.data.data.result_header
          const adjustData = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }
          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })
          dispatch(fetchAdjustSuccess(dataWithOption, pagination, total, adjustData))
        }
      })
      .catch(error => {
        dispatch(fetchAdjustFailed(error))
      })
  }
}

export const fetchAdjustStart = () => {
  return {
    type: actionTypes.FETCH_ADJUST_START
  }
}

export const fetchAdjustSuccess = (data, pagination, total, adjustData) => {
  return {
    type: actionTypes.FETCH_ADJUST_SUCCESS,
    data,
    pagination,
    total,
    adjustData
  }
}

export const fetchAdjustFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ADJUST_FAILED,
    errorMessage
  }
}

export const clearHorizontalRecord = () => {
  return {
    type: actionTypes.CLEAR_HORIZONTAL_RECORD
  }
}
